import * as React from "react";
import { useFeatureToggles } from "@grandvisionhq/state";
const VtoContext = React.createContext(null);
VtoContext.displayName = "VtoContext";
const useVto = () => {
  const context = React.useContext(VtoContext);
  if (!context) {
    throw new Error(
      `No ${VtoContext.displayName} available. You might need to add the ${VtoContext.displayName} provider component.`
    );
  }
  return context;
};
const VtoProvider = ({ config, children }) => {
  const { isVtoEnabled } = useFeatureToggles();
  const [isVtoActive, setVtoActive] = React.useState(false);
  const [vmApp, setVmApp] = React.useState(null);
  const value = React.useMemo(
    () => ({
      config,
      isVtoActive,
      setVtoActive,
      isVtoFeatureEnabled: isVtoEnabled,
      vmApp,
      setVmApp
    }),
    [config, isVtoActive, isVtoEnabled, vmApp]
  );
  return /* @__PURE__ */ React.createElement(VtoContext.Provider, { value }, children);
};
export {
  VtoContext,
  VtoProvider,
  useVto
};
//# sourceMappingURL=VtoProvider.js.map
